module.exports = __webpack_public_path__ + "static/Abel-65936a246e574a8b65d2b1d73b2ea5d7.jpg";